import React from "react";

function Cabins() {
  return (
    <div>
      <h2>Hytter</h2>
      <p>
        HRiis disponerer tre hytter, samt møtelokale på Skådalen:
      </p>
      <p>
        Ukentlige møter holdes oftest i eller i nærheten av speiderhuset/barnehagen på Skådalen.
        Ligger på markagrensa, ligger hundre meter fra nærmeste t-banestasjon, og har parkeringsplass.
      </p>
      <p>
        Riiskollen er ei hytte i nærheten av Brunkollen turisthytte i Bærumsmarka.
        Det tar en times tid å traske hit både sommer og vinter fra parkeringsplassen på Skytterkollen/Løvenskioldbanen.
      </p>
      <p>
        Holmenkollhytta ligger i samme område som Riiskollen.
      </p>
      <p>
        Hytta ved Blekkvann ligger om lag 5 kilometer fra parkeringen ved Årnes i Sørkedalen.
        Hit vandrer vi både til fots og på ski.
      </p>
    </div>
  );
}

export default Cabins;